export const CREDITS_LEDGER_PERMISSION = 'credits:list';
export const CREDITS_GIFT_PERMISSION = 'credits:gift';
export const CREDITS_RECHARGE_PERMISSION = 'credits:recharge';
export const CREDITS_ORG_ADJUST_PERMISSION = 'credits:org_adjust';

export const MOBILE_CREDITS_PERMISSIONS = [
  CREDITS_RECHARGE_PERMISSION,
  CREDITS_ORG_ADJUST_PERMISSION,
] as const;

export const CREDITS_PAGE_PERMISSIONS = [
  CREDITS_LEDGER_PERMISSION,
  CREDITS_GIFT_PERMISSION,
  CREDITS_RECHARGE_PERMISSION,
  CREDITS_ORG_ADJUST_PERMISSION,
] as const;

export function canShowCreditsLedgerTab(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(CREDITS_LEDGER_PERMISSION);
}

export function canShowTeamRechargeTab(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(CREDITS_ORG_ADJUST_PERMISSION);
}
